import BaseApiAction from '@Actions/base-api-action';

export default class CreateReplay extends BaseApiAction {
    runAction() {
        super.invokeCloudFunction({
            name: 'replays-createReplay',
            payload: {
                user_id: this._payload.user_id,
                cognitive_result_id: this._payload.cognitive_result_id,
            },
        });
    }
}
